//const BOHEMIA_REGEX = /^http(s)?:\/\/\w{3}prodprv\.www\.office\.com/;
//const ROUTERLICIOUS_REGEX = /^(http(s)?:\/\/)?www\..{3,9}\.prague\.office-int\.com\/loader\/.*/;
const NEW_BOHEMIA_REGEX = /^(http(s)?:\/\/)?(www\.)?dev\.fluid\.office\.com(:443)?\/[pc]\/.*/;
import { isFeatureEnabled } from 'owa-feature-flags';

export default function isValidPragueURL(questionedURL: string): boolean {
    return (
        isFeatureEnabled('cmp-pragueAnyLink') ||
        //BOHEMIA_REGEX.test(questionedURL) ||
        //ROUTERLICIOUS_REGEX.test(questionedURL) ||
        NEW_BOHEMIA_REGEX.test(questionedURL)
    );
}
